import './index.css';
import * as React from 'react';
import { CSSProperties } from 'react';
import clsx from 'clsx';

interface IState {
}
interface Props {
  children: any; //内部组件
  wrap?: boolean;
  maskKey?: string; // 蒙层唯一key 需是随机值 当前仅多规格页加购按钮会传入值
  onClick?: () => void;
  style?: CSSProperties;
  wrapStyle?: CSSProperties;
  // 添加白色蒙层
  white?: boolean;
  // 热区
  hitSlop?: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
  // 是否可点击
  isDisabled?: boolean;
}
export default class HoverContainer extends React.Component<Props, IState> {
  render() {
    const { wrap, wrapStyle, hitSlop } = this.props;
    return wrap ? (
      <view hitSlop={hitSlop ?? {}} style={wrapStyle ?? {}}>
        {this.renderView()}
      </view>
    ) : (this.renderView());
  }
  renderView() {
    const {
      children,
      onClick,
      style,
      white,
      hitSlop,
      maskKey,
      isDisabled = false,
    } = this.props;

    const handleClick = () => {
      if (onClick && !isDisabled) {
        onClick?.();
      }
    };

    return (
      <>
        {children}
        {maskKey ? ( // 多规格页加购按钮会传入值 需是随机值 其他优化写法安卓不同系统有兼容性问题 故为现在写法
          <view
            key={maskKey} // 有值时设置key 无值时不设置key
            className="add-mask-transparent"
            hitSlop={hitSlop ?? {}}
            style={style ?? {}}
            hoverClass={clsx(isDisabled ? '' : 'add-mask', { white })}
            onClick={handleClick}
          />
        ) : (
          <view // (历史代码)
            className="add-mask-transparent"
            hitSlop={hitSlop ?? {}}
            style={style ?? {}}
            hoverClass={clsx(isDisabled ? '' : 'add-mask', { white })}
            onClick={handleClick}
          />
        )}
      </>
    );
  }
}
